import { PageCardActions } from './Actions';
import { PageCardApiResponse } from './ApiResponse';
import { PageCard } from './Card';
import { PageCardEvents } from './Events';
import { PageCardInformation } from './Information';
import { PageCardsOverview } from './Overview';
import { PageCardTokens } from './Tokens';
import { PageCardTransactions } from './Transactions';

export { PageCardsOverview } from './Overview';

export const CARDS = {
  Cards: PageCardsOverview,
  CardSection: PageCard,
  CardEdit: PageCardInformation,
  CardTokens: PageCardTokens,
  CardTransactions: PageCardTransactions,
  CardEvents: PageCardEvents,
  CardActions: PageCardActions,
  CardApiResponse: PageCardApiResponse,
} as const;
